module.exports = __webpack_public_path__ + "static/media/logocdsmais.3d256c40.svg";